function MiitBeian(){
    return(
        <p className="recordcode"><a
            href="https://beian.miit.gov.cn" target="_blank" rel="noreferrer"><i
            className="icon-police"></i>蒙ICP备2023000618号-1</a></p>
    );
}

export default MiitBeian;